import {
  AssignTemplateRequest,
  MailroomShippingLabelTemplate,
  MailroomShippingLabelTemplateResponse,
  PrintLabelResponse,
  ShippingLabelPrintLabelTemplateCreateParams,
} from '@apiContract';

import { receivedDigitalApi } from './index';

const shippingLabelApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getShippingLabel: builder.query<MailroomShippingLabelTemplate, void>({
      query: () => 'shippingLabel',
      providesTags: ['ConnectInstance'],
      transformResponse: (response: MailroomShippingLabelTemplateResponse): MailroomShippingLabelTemplate =>
        response.objectData,
    }),
    printLabel: builder.mutation<PrintLabelResponse, { rdConnectInstanceId: number; id: number }>({
      query: (requestData) => ({
        url: `ShippingLabel/print-label/${requestData.rdConnectInstanceId}/${requestData.id}`,
        method: 'POST',
      }),
    }),
    applyOptions: builder.mutation<MailroomShippingLabelTemplateResponse, AssignTemplateRequest>({
      query: (requestData) => ({
        url: 'ShippingLabel',
        method: 'POST',
        body: requestData,
      }),
    }),
    testPagePrint: builder.mutation<PrintLabelResponse, ShippingLabelPrintLabelTemplateCreateParams>({
      query: (requestData) => ({
        url: `ShippingLabel/print-label-template?rdConnectInstanceId=${requestData.rdConnectInstanceId}`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetShippingLabelQuery,
  usePrintLabelMutation,
  useApplyOptionsMutation,
  useTestPagePrintMutation,
} = shippingLabelApi;
